import { App } from '@src/app/layout';
import {
  isTemporaryAuthError,
  saveReturnUrl,
} from '@src/features/auth';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app')({
  beforeLoad: async ({ context, location }) => {
    const { auth } = context;
    try {
      await auth.verifyToken();
    } catch (verificationError) {
      if (
        isTemporaryAuthError(verificationError) &&
        auth.credentials
      ) {
        return;
      }

      try {
        await auth.refreshToken();
      } catch (refreshError) {
        if (isTemporaryAuthError(refreshError)) {
          throw refreshError;
        }

        const returnUrl = saveReturnUrl(
          location.href,
          auth.credentials?.user?.id,
        );
        throw redirect({
          to: '/auth/login',
          search: returnUrl === '/' ? {} : { redirect: returnUrl },
          replace: true,
        });
      }
    }
  },
  component: App,
});
